/* OPTIMIZATION 04: product card image slider moved out of an inline head script into this deferred file. Code is unchanged. */
  (function () {
    if (window.__arotagasCardSlider) return;
    window.__arotagasCardSlider = true;

    var WIDTHS = [400, 600, 800, 1000, 1200];
    var INITIAL_SLIDES = 4;

    function fileKey(url) {
      return (url || '').split('?')[0].split('/').pop();
    }

    function fullUrl(prefix, entry, width) {
      return prefix + entry + (entry.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    function isBrowsing(figure) {
      return figure.style.getPropertyValue('--arotagas-browsing') === '1';
    }

    function markBrowsing(figure) {
      if (!isBrowsing(figure)) figure.style.setProperty('--arotagas-browsing', '1');
    }

    // One picture width per card, from the strip's width and the screen's
    // pixel density, so a preloaded file is the same file the slide uses.
    function urlFor(state, entry) {
      if (!state.width) {
        var need = (state.track.clientWidth || 300) * (window.devicePixelRatio || 1);
        state.width = WIDTHS[WIDTHS.length - 1];
        for (var i = 0; i < WIDTHS.length; i++) { if (WIDTHS[i] >= need) { state.width = WIDTHS[i]; break; } }
      }
      return fullUrl(state.prefix, entry, state.width);
    }

    // Warms the browser cache without touching the page: an <img> outside
    // the document costs no style work on this heavy page.
    function preload(state, slide) {
      var img = slide && slide.firstElementChild;
      if (!img || img.hasAttribute('src')) return;
      var probe = new Image();
      probe.src = urlFor(state, slide.getAttribute('data-entry'));
    }

    // Assigns the picture to a slide's waiting <img>: one attribute change.
    // OPTIMIZATION 26: "urgent" is a photo the shopper is about to see because they touched, swiped or tapped
    // an arrow on this card. Only those ask Safari for high priority. Photos fetched ahead of time use normal
    // priority, so they never slow down the product photos coming into view while the row is swiped.
    function fill(state, slide, urgent) {
      var img = slide.firstElementChild;
      if (!img || img.hasAttribute('src')) return;
      if (urgent) img.setAttribute('fetchpriority', 'high');
      img.src = urlFor(state, slide.getAttribute('data-entry'));
    }

    function makeSlide(state, entry) {
      var slide = document.createElement('div');
      slide.className = 'arotagas-slide arotagas-slide--lazy';
      slide.setAttribute('data-entry', entry);
      var img = document.createElement('img');
      img.alt = state.alt;
      img.draggable = false;
      img.decoding = 'async';
      slide.appendChild(img);
      if (state.observer && state.started) state.observer.observe(slide);
      return slide;
    }

    // Appends the slides that were held back (products with many pictures).
    function appendRest(state) {
      if (!state.rest.length) return;
      var fragment = document.createDocumentFragment();
      state.rest.forEach(function (entry) { fragment.appendChild(makeSlide(state, entry)); });
      state.rest = [];
      state.track.appendChild(fragment);
      state.count = state.track.children.length;
    }

    // The other pictures in media order, starting after the one on the card.
    // The catalogue keeps each colour's photos together, each group starting
    // with that colour's variant photo, so the variant photos of the OTHER
    // colours (from the swatches under the card) mark where the current
    // colour's photos end: the strip stops there instead of running on into
    // the next colour. Without swatches the strip runs through every photo.
    function ringAfter(entries, src, boundaries) {
      var shown = fileKey(src);
      var start = 0;
      for (var i = 0; i < entries.length; i++) {
        if (fileKey(entries[i]) === shown) { start = i; break; }
      }
      var ring = [];
      for (var j = 1; j < entries.length; j++) {
        var index = (start + j) % entries.length;
        if (index === 0 && boundaries && boundaries.length) break;
        var entry = entries[index];
        if (boundaries && boundaries.indexOf(fileKey(entry)) > -1) break;
        ring.push(entry);
      }
      return ring;
    }

    // After a colour swatch put another picture on the card, the slides that
    // follow must be the ones after THAT picture. Existing slides are reused:
    // attributes only, no DOM insertion.
    function reorder(state, src) {
      var ring = ringAfter(state.entries, src, state.boundaries);
      var slides = state.track.children;
      for (var i = 1; i < slides.length; i++) {
        var slide = slides[i];
        var entry = ring[i - 1];
        if (!entry) break;
        if (slide.getAttribute('data-entry') === entry) continue;
        slide.setAttribute('data-entry', entry);
        var img = slide.firstElementChild;
        if (img) {
          img.removeAttribute('src');
          if (state.observer && state.started) state.observer.observe(slide);
        }
      }
      // A colour with fewer pictures than the slides already built: the
      // leftover slides would keep showing the previous colour, so drop them.
      while (slides.length > ring.length + 1) {
        var extra = slides[slides.length - 1];
        if (state.observer) state.observer.unobserve(extra);
        state.track.removeChild(extra);
      }
      // And the other way round: enough slides to swipe on again.
      while (slides.length < Math.min(ring.length + 1, INITIAL_SLIDES)) {
        state.track.appendChild(makeSlide(state, ring[slides.length - 1]));
      }
      state.rest = ring.slice(slides.length - 1);
      state.count = slides.length;
    }

    // Builds a card's state and its first slides. Returns the fragment to
    // insert so many cards can be inserted in one batch.
    function prepareState(figure) {
      if (figure.__arotagas) return null;
      var track = figure.querySelector('.arotagas-track');
      var holder = figure.querySelector('.arotagas-card-media');
      var primary = figure.querySelector('.product-card__image--primary');
      if (!track || !holder || !primary) return null;

      var entries = (holder.getAttribute('data-urls') || '').split('|').filter(Boolean);
      var src = primary.currentSrc || primary.src || '';
      var prefix = src.split('/cdn/shop/')[0] + '/cdn/shop/';
      var boundaries = [];
      var card = figure.closest('product-card');
      var swatches = card ? card.querySelectorAll('.product-card__info input[data-variant-media]') : [];
      for (var s = 0; s < swatches.length; s++) {
        try {
          var m = JSON.parse(swatches[s].getAttribute('data-variant-media'));
          var key = fileKey(m && (m.src || (m.preview_image && m.preview_image.src)));
          if (key && boundaries.indexOf(key) < 0) boundaries.push(key);
        } catch (e) {}
      }
      var ring = ringAfter(entries, src, boundaries);

      var state = {
        track: track,
        figure: figure,
        primary: primary,
        entries: entries,
        boundaries: boundaries,
        width: 0,
        prefix: prefix,
        alt: primary.alt || '',
        rest: ring.slice(INITIAL_SLIDES - 1),
        count: 1,
        observer: null,
        active: false
      };
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(function (records) {
          records.forEach(function (record) {
            if (record.isIntersecting) { fill(state, record.target, isBrowsing(state.figure)); state.observer.unobserve(record.target); }
          });
        }, { root: track, rootMargin: '0px 100% 0px 0px', threshold: 0 }); /* OPTIMIZATION 24: back to the original rule, the photo next to the one on screen is always ready before a swipe. It only applies once the card itself is on screen (activate()), so cards further down the page do not all download their second photo at once */
      }
      var fragment = document.createDocumentFragment();
      ring.slice(0, INITIAL_SLIDES - 1).forEach(function (entry) { fragment.appendChild(makeSlide(state, entry)); });
      state.count = 1 + Math.min(ring.length, INITIAL_SLIDES - 1);
      figure.__arotagas = state;

      track.addEventListener('scroll', function () {
        if (track.scrollLeft > 4) {
          markBrowsing(figure);
          /* During a swipe: the next photo is requested right away, not after the swipe settles */
          var next = track.children[currentSlide(state) + 1];
          if (next) fill(state, next, true);
          if (state.rest.length && currentSlide(state) >= state.count - 2) appendRest(state);
        }
      }, { passive: true });

      return { figure: figure, track: track, fragment: fragment };
    }

    // One batch: every card on the page, one style pass.
    function buildAll(root) {
      var figures = (root || document).querySelectorAll('.product-card__figure');
      var jobs = [];
      for (var i = 0; i < figures.length; i++) {
        var job = prepareState(figures[i]);
        if (job) jobs.push(job);
      }
      jobs.forEach(function (job) { job.track.appendChild(job.fragment); });
      return jobs.length;
    }

    // OPTIMIZATION 24: a card's slides start loading when the card is on screen: the photo after the one shown is
    // downloaded right away, so the first swipe never shows an empty slide. Safari can hold observer callbacks
    // back during a fast scroll, so touching a card also does this on the spot (prepare()).
    function activate(state) {
      if (!state || state.active) return;
      state.active = true;
      // OPTIMIZATION 26: the card's own photo comes first; its second photo starts once that one has arrived.
      var primary = state.primary;
      if (primary && !(primary.complete && primary.naturalWidth > 0)) {
        var go = function () {
          primary.removeEventListener('load', go);
          primary.removeEventListener('error', go);
          startSlides(state);
        };
        primary.addEventListener('load', go);
        primary.addEventListener('error', go);
        return;
      }
      startSlides(state);
    }

    function startSlides(state) {
      if (state.started) return;
      state.started = true;
      var slides = state.track.children;
      if (slides[1]) fill(state, slides[1]);
      if (!state.observer) return;
      for (var i = 1; i < slides.length; i++) {
        var img = slides[i].firstElementChild;
        if (img && !img.hasAttribute('src')) state.observer.observe(slides[i]);
      }
    }

    var cardObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cardObserver.unobserve(entry.target);
        var figure = entry.target.closest('.product-card__figure');
        activate(figure && figure.__arotagas);
      });
    }, { rootMargin: '100px 0px', threshold: 0 }) : null;

    function setup(figure) {
      if (figure.__arotagas) return figure.__arotagas;
      var job = prepareState(figure);
      if (!job) return null;
      job.track.appendChild(job.fragment);
      activate(figure.__arotagas);
      return figure.__arotagas;
    }

    function currentSlide(state) {
      var width = state.track.clientWidth || 1;
      return Math.round(state.track.scrollLeft / width);
    }

    function goTo(state, index, instant) {
      var n = state.count;
      index = ((index % n) + n) % n;
      var slide = state.track.children[index];
      if (slide && slide.classList.contains('arotagas-slide--lazy')) fill(state, slide, true);
      state.track.scrollTo({ left: index * state.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }

    function step(figure, delta) {
      var state = setup(figure);
      if (!state) return;
      activate(state);
      var index = currentSlide(state);
      var target = index + delta;
      if (!isBrowsing(figure) && index === 0 && delta > 0) {
        // The theme's hover image (picture 2) is on screen: the first click
        // on the right arrow should show picture 3.
        var hover = figure.querySelector('.product-card__image--secondary');
        if (hover && getComputedStyle(hover).opacity === '1' && state.count > 2) target = 2;
      }
      markBrowsing(figure);
      if (state.rest.length && target >= state.count - 2) appendRest(state);
      var wraps = target < 0 || target >= state.count;
      goTo(state, target, wraps);
      startSlides(state);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.arotagas-card-nav');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      step(button.closest('.product-card__figure'), button.classList.contains('arotagas-card-nav--next') ? 1 : -1);
    }, true);

    // The other colours' photos for a card, fetched ahead of a tap on a
    // swatch. The theme swaps the card photo only once the new file has
    // arrived, and a size Shopify has not served before takes up to a second
    // to generate, so the swap felt slow. The probe uses the very same
    // srcset and sizes the theme will build, so the browser asks for the same
    // file and the swap then comes straight from cache. Hover already does
    // this on desktop through the theme; this covers phones.
    var SWATCH_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
    var WARM_LIMIT = 80;
    var warmed = 0;

    function warmSwatches(card) {
      if (!card || card.getAttribute('data-arotagas-warm') === 'true') return;
      card.setAttribute('data-arotagas-warm', 'true');
      var primary = card.querySelector('.product-card__image--primary');
      if (!primary) return;
      var sizes = primary.getAttribute('sizes') || '';
      var inputs = card.querySelectorAll('.product-card__info input[data-variant-media]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked || warmed >= WARM_LIMIT) continue;
        var media = null;
        try { media = JSON.parse(inputs[i].getAttribute('data-variant-media')); } catch (e) { continue; }
        var image = media && media.preview_image;
        if (!image || !image.src) continue;
        var url = null;
        try { url = new URL(image.src.indexOf('//') === 0 ? 'https:' + image.src : image.src); } catch (e) { continue; }
        var parts = [];
        for (var w = 0; w < SWATCH_WIDTHS.length; w++) {
          if (SWATCH_WIDTHS[w] > image.width) continue;
          url.searchParams.set('width', String(SWATCH_WIDTHS[w]));
          parts.push(url.href + ' ' + SWATCH_WIDTHS[w] + 'w');
        }
        if (!parts.length) continue;
        var probe = new Image();
        probe.sizes = sizes;
        probe.srcset = parts.join(', ');
        warmed++;
      }
    }

    // Cards that stay in view for a moment get their other colours fetched
    // during idle time: that is the card a thumb is about to tap.
    var warmTimers = new WeakMap();
    var warmObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        if (entry.isIntersecting) {
          if (warmTimers.has(card)) return;
          warmTimers.set(card, setTimeout(function () {
            warmTimers.delete(card);
            if ('requestIdleCallback' in window) requestIdleCallback(function () { warmSwatches(card); }, { timeout: 1500 });
            else warmSwatches(card);
            warmObserver.unobserve(card);
          }, 400));
        } else if (warmTimers.has(card)) {
          clearTimeout(warmTimers.get(card));
          warmTimers.delete(card);
        }
      });
    }, { threshold: 0.4 }) : null;

    function watchCards(root) {
      if (!warmObserver) return;
      var cards = root.querySelectorAll('product-card');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-arotagas-warm') === 'true' || cards[i].querySelectorAll('.product-card__info input[data-variant-media]').length < 2) continue;
        warmObserver.observe(cards[i]);
      }
    }

    // On touch or hover: make sure the card is built (a no-op after the
    // batch) and warm the cache for the neighbouring slides, off the page.
    function prepare(event) {
      var target = event.target;
      var card = target.closest && target.closest('product-card');
      if (card) warmSwatches(card);
      var figure = target.closest && target.closest('.product-card__figure');
      if (!figure || !figure.querySelector('.arotagas-track')) return;
      var state = setup(figure);
      if (!state) return;
      activate(state);
      var slides = state.track.children;
      if (slides[1]) fill(state, slides[1], true);
      startSlides(state);
      if (slides.length > 2) preload(state, slides[slides.length - 1]);
    }
    document.addEventListener('touchstart', prepare, { passive: true, capture: true });
    document.addEventListener('mouseover', prepare, { passive: true, capture: true });

    // A colour swatch under the card swaps the theme's own image, which lives
    // in the first slide: bring the strip back to it and line the other
    // slides up behind that colour's picture.
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('.product-card__info input[data-variant-media]')) return;
      var card = input.closest('product-card');
      var figure = card && card.querySelector('.product-card__figure');
      var state = figure && setup(figure);
      if (!state) return;
      var media = null;
      try { media = JSON.parse(input.getAttribute('data-variant-media')); } catch (e) {}
      var src = media && (media.src || (media.preview_image && media.preview_image.src));
      if (src) reorder(state, src);
      state.track.scrollTo({ left: 0, behavior: 'auto' });
      markBrowsing(figure);
    }, true);

    // The batch waits for a real idle moment so it never lands in the middle
    // of a scroll; a timer is the guard (background tabs hold idle callbacks
    // back for a long time). A card touched before the batch is built on its
    // own by prepare().
    // OPTIMIZATION 23 (measured on iPhone, Safari Web Inspector timeline): Safari has no
    // requestIdleCallback, so the batch below always ran on the 5 s timer, in the middle of the
    // shopper's scroll. In the recording that one moment built slides for every card on the page,
    // started about 64 photo downloads at once and froze the page for 88 ms and then 269 ms.
    // Cards are now built one at a time, only when a shopper touches, hovers or taps an arrow on
    // that card (prepare() and step() already did this), so scrolling never pays for it.
    // Cards are now built one section at a time, shortly before that section scrolls into view
    // (small batches instead of the whole page at once). OPTIMIZATION 24: a card's second photo
    // downloads as soon as that card is on screen (activate()), so it is there on the first swipe.
    // A card touched before its section was built is built on the spot by prepare(), as before.
    void buildAll; void watchCards;
    function buildSection(root) {
      var figures = root.querySelectorAll('.product-card__figure');
      var jobs = [];
      for (var i = 0; i < figures.length; i++) {
        var job = prepareState(figures[i]);
        if (job) jobs.push(job);
      }
      jobs.forEach(function (job) {
        job.track.appendChild(job.fragment);
        if (cardObserver) cardObserver.observe(job.track);
        else activate(job.figure.__arotagas);
      });
    }
    function watchSections() {
      var sections = document.querySelectorAll('.shopify-section');
      if (!('IntersectionObserver' in window)) {
        for (var k = 0; k < sections.length; k++) buildSection(sections[k]);
        return;
      }
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          sectionObserver.unobserve(entry.target);
          buildSection(entry.target);
        });
      }, { rootMargin: '400px 0px' });
      for (var j = 0; j < sections.length; j++) {
        if (sections[j].querySelector('.product-card__figure .arotagas-track')) sectionObserver.observe(sections[j]);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSections, { once: true });
    else watchSections();
  })();